import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">页面走丢了</h2>
        <p className="mt-2 text-sm text-foreground-500 font-label">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-600">该地址不存在，你可以回到首页继续浏览或投稿。</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-left-line" aria-hidden="true" />
          返回首页
        </Link>
      </div>
    </div>
  );
}